<template>
  <div v-if="links && links.length > 0" class="hots">
    <SidebarTitle :title="title" />
    <Range
      v-for="(range, index) in links"
      :key="index"
      :text="range.name || range.title"
      :width="range.width || range.weight"
      :category="jurisdictionFromContent ? type : range.vid || range.vid || null"
      :tid="jurisdictionFromContent ? tid : range.tid || null"
      :jurisdiction="jurisdictionFromContent ? range.tid : tid || range.jurisdiction || null"
      :topic="topic || null"
      :type="jurisdictionFromContent ? type : range.vid"
    />
  </div>
</template>

<script>
export default {
  name: "Hots",
  components: {
    SidebarTitle: () => import("./SidebarTitle"),
    Range: () => import("../../components/elements/Range"),
  },
  props: {
    title: {
      type: String,
      default: null,
    },
    links: {
      type: Array,
      default: null,
    },
    topic: {
      type: Number,
      default: null,
    },
    tid: {
      type: [Number, String],
      default: null,
    },
    type: {
      type: String,
      default: null,
    },
    jurisdictionFromContent: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style scoped lang="scss">
.hots {
  margin-bottom: 2.8rem;
}
</style>
